export const mapSelected = (leagues, selectedLeagues) => {
    leagues.forEach((league, i) => {
        const id = selectedLeagues.find(id => league.id === id);
        if (id) {
            league.isSelected = true;
        }
        else {
            league.isSelected = false;
        }
    });
    return leagues;
};
//# sourceMappingURL=mapSelected.js.map